function get_export_value_text(value) {
  if (!value || typeof value !== "object") {
    return value;
  }

  return Reflect.get(value, "text");
}

function get_survey_result_export_value_from_header(application, header, value_key) {
  return get_export_header_value(application, header, value_key);
}

function get_export_header_value(application, header, value_key) {
  return get_export_header_named_value(application, header, value_key) ?? get_export_header_fallback_value(application, header);
}

function get_export_header_named_value(application, value_key) {
  const value_map = {
    name: application.respondent_name || "",
    email: application.respondent_email || "",
  };

  const mapped_value = Reflect.get(value_map, value_key);
  return mapped_value;
}

function get_export_header_fallback_value(application, header) {
  return Reflect.get(application.answers || {}, header) || "";
}

function should_export_file_answer(survey_question, file_url) {
  const question_type = Reflect.get(survey_question?.question?.question_type, "question_type") || "";
  return question_type === "file" && Boolean(file_url);
}

function get_export_row_values(row) {
  return Array.isArray(row) ? row : Object.values(row || {});
}

function get_survey_file_input_file(files) {
  return typeof files?.item === "function" ? files.item(0) : null;
}

function should_process_survey_file(file) {
  return Boolean(file);
}

function get_survey_result_response_key(user_id, survey_question, question_index, answer_index) {
  if (user_id !== undefined && user_id !== null) {
    return `user-${user_id}`;
  }

  return `anonymous-${survey_question?.id || question_index}-${answer_index}`;
}
function get_survey_result_user_name(user) {
  if (user?.is_blocked) {
    return "Unknown User";
  }

  const first_name = user?.first_name;
  const last_name = user?.last_name;
  const display_name = `${first_name} ${last_name}`.trim();

  if (display_name) {
    return display_name;
  }

  return "Unknown User";
}

function get_survey_result_row(respondents, response_key, user) {
  if (!respondents.has(response_key)) {
    respondents.set(response_key, {
      respondent_name: get_survey_result_user_name(user),
      respondent_email: user?.email || "",
      answers: {},
    });
  }

  return respondents.get(response_key);
}

function append_export_answer_to_row_if_needed(instance, respondents, survey_question, question_text, question_index, answer, answer_index) {
  return append_export_answer_to_row_entry(instance, respondents, survey_question, question_text, question_index, answer, answer_index);
}

function append_export_answer_to_row_entry(instance, respondents, survey_question, question_text, question_index, answer, answer_index) {
  return write_export_answer_to_row(instance, respondents, survey_question, question_text, question_index, answer, answer_index);
}

function append_export_file_answer(row, question_text, file_url, file_name) {
  Reflect.set(row.answers, question_text, {
    text: file_name,
    hyperlink: file_url,
  });
}

function append_export_text_answer(row, question_text, next_answer) {
  const current_answer = Reflect.get(row.answers, question_text);

  if (!current_answer) {
    Reflect.set(row.answers, question_text, next_answer);
    return;
  }

  const values = String(current_answer || "")
    .split(",")
    .map((item) => item.trim())
    .filter(Boolean);

  if (!values.includes(next_answer)) {
    values.push(next_answer);
  }

  Reflect.set(row.answers, question_text, values.join(", "));
}

function append_export_answer(instance, row, survey_question, question_text, answer) {
  const file_url = instance.get_survey_answer_file_url(answer);

  if (should_export_file_answer(survey_question, file_url)) {
    append_export_file_answer(row, question_text, file_url, instance.get_survey_answer_file_name(answer));
    return;
  }

  const text = String(answer?.answer || "").trim();

  if (text) {
    append_export_text_answer(row, question_text, text);
  }
}

function write_export_answer_to_row(instance, respondents, survey_question, question_text, question_index, answer, answer_index) {
  const user = answer?.user || {};
  const response_key = get_survey_result_response_key(
    user?.id,
    survey_question,
    question_index,
    answer_index
  );
  const row = get_survey_result_row(respondents, response_key, user);

  append_export_answer(instance, row, survey_question, question_text, answer);
}
export {
  append_export_answer_to_row_if_needed,
  get_export_row_values,
  get_export_value_text,
  get_survey_file_input_file,
  get_survey_result_export_value_from_header,
  get_survey_result_response_key,
  get_survey_result_row,
  should_export_file_answer,
  should_process_survey_file,
};
